export class ClearJobsLoadingStatus {
    public static readonly type = '[JobsPlacements] Clear jobs loading status';
}
